export enum WebSocketChannel {
  PING = "ping",
  PONG = "pong",

  PROCESS_REQUEST = "process-request",
  CONFIG_UPDATE = "config-update",
  NAVIGATION_STATE = "app-state",

  ERROR = "error", // TODO

  CHAT = "chat",
  CHAT_INITIATE = "chat-initiate",
  CHAT_TEMPLATES = "templates",
  CHAT_FEEDBACK = "feedback",

  SOCKET_TEMPLATES = "socket-templates",

  SUGGESTIONS = "suggestions",

  AUDIO_START = "audio-start",
  AUDIO_BLOB = "audio-blob",
  AUDIO_END = "audio-end",

  VOICE_START = "start-voice",
  VOICE_STOP = "stop-voice",
  VOICE_TRANSCRIPTION = "transcription",
  VOICE_FULL_TRANSCRIPT = "chat-transcript",
  VOICE_DATA = "voice-data", // Only internally used, because blob will be directly sent to the server without a channel

  UI_CONTEXT = "ui-context",

  STOP_ALL = "stfu",

  ACTION = "action", // TODO Verify naming with BE

  REGISTER_PROGRESS_LISTENER = "register-progress-listener",
  UNREGISTER_PROGRESS_LISTENER = "unregister-progress-listener",
  PROGRESS_UPDATE = "progress-update",

  INTERIOR_DESIGNER_GENERATION = "interior_designer_generation",
}
